import * as React from 'react';
import { APILoadingStatus, useApiLoadingStatus } from '@vis.gl/react-google-maps';
import { setGoogleMapsLoadError, setGoogleMapsLoaded } from 'actions/AppActions';
import { useDispatch } from 'react-redux';

/**
 * Headless bridge that mirrors vis.gl's API loading status into the existing
 * Redux `app.googleMapsLoaded` / `app.googleMapsLoadError` state (via
 * {@link setGoogleMapsLoaded} / {@link setGoogleMapsLoadError}). This keeps
 * `GoogleMapsContext` and every current load-state consumer
 * (`DeliveryAddressRoute`, `LocationAwareCreditCardForm`,
 * `CulinaryTravelLogSection`, `PatronLocationContainer`, `useIsGoogleMapsLoaded`)
 * working unchanged when the flag is ON — only the source of truth behind the
 * bridge changes (vis.gl instead of `useLoadScript`).
 */
const MapsLoadStateBridge: React.FunctionComponent = () => {
  const dispatch = useDispatch();
  const status = useApiLoadingStatus();

  React.useEffect(() => {
    if (status === APILoadingStatus.LOADED) {
      dispatch(setGoogleMapsLoaded(true));
    } else if (status === APILoadingStatus.FAILED || status === APILoadingStatus.AUTH_FAILURE) {
      dispatch(setGoogleMapsLoadError(new Error(`Google Maps API failed to load: ${status}`)));
    }
  }, [dispatch, status]);

  return null;
};

export default MapsLoadStateBridge;
